// extracted by mini-css-extract-plugin
module.exports = {"spinner":"dd31006766--spinner--v_ne6","circle-spin":"dd31006766--circle-spin--LJJNY"};